import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/leave-management/leave-management.css";
import { selectAuth } from "../../components/auth/auth.selector";
import StaffListings from "../../components/leave-management/staff/StaffListings";
import CommonStructured from "../../components/common-components/CommonStructured";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import LeaveCategory from "../../components/leave-management/admin/LeaveCategory";
import ApprovalManager from "../../components/leave-management/approval/ApprovalManager";
import HelmetWrapper from "../../HelmetWrapper";

const LeaveManagement = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const isAdmin = userInfoData?.account_type === "admin";

  const iniModValues = {
    isModOpen: false,
    cardType: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onClickModal = (name) => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      cardType: name,
    }));
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  return (
    <HelmetWrapper title="WTF: Leave Management">
      <Container
        className="bg-cloud-k px-50px daily-target-metrics-container"
        fluid
      >
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Manage Leave Categories Modal"
          ariaHideApp={false}
        >
          <div className="createNewCTOModalContainer">
            <ModalHeadAndClose
              title={`${modValues.cardType?.replace(/-/g, " ")}`}
              onClose={onCloseModal}
            />

            {modValues.cardType === "manage-leave-categories" ? (
              <LeaveCategory userInfoData={userInfoData} />
            ) : modValues.cardType === "manage-approval-manager" ? (
              <ApprovalManager userInfoData={userInfoData} />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Leave Management"}
              createBtnTxt={isAdmin ? "Manage Leave Category" : null}
              createBtnTxt1={isAdmin ? "Manage Approval Manager" : null}
              onClickCreateBtn={
                isAdmin ? () => onClickModal("manage-leave-categories") : null
              }
              onClickCreateBtn1={
                isAdmin ? () => onClickModal("manage-approval-manager") : null
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <StaffListings userInfoData={userInfoData} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default LeaveManagement;
